// @ts-nocheck
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import Select, { components as RSComponents } from "react-select";
import { QRCodeSVG } from "qrcode.react";
import EmailInputWithDomainSuggest from "../../../customComponents/EmailInputWithDomainSuggest";
import { alertErrorMessage } from "../../../customComponents/CustomAlertMessage";
import {
  coinSymbol,
  coinWithdrawListHint,
  isMetaMaskWhitelistChain,
  truncateMid,
} from "./withdrawPageHelpers";
import {
  addressBookDeleteConfirmMessage,
  addressBookDeleteConfirmTitle,
  addressBookEntryPendingMetaMaskSignature,
  addressBookEntryPendingSatoshiDeposit,
  addressBookEntryWithdrawable,
  addressBookStatusBadgeLabel,
  formatWhitelistExpiry,
  formatWithdrawAddressHistoryDate,
  METAMASK_DOWNLOAD_URL,
  SELECT_COIN_PLACEHOLDER,
  StepBadge,
  withdrawStatusTone,
  WithdrawCoinThumb,
  WithdrawButtonSpinner,
  SAVE_ADDR_WIZARD_STEP,
  ADDRESS_BOOK_TOP_EXCHANGES,
  ADDRESS_BOOK_DECLARATION_TEXT,
  ADDRESS_BOOK_EXCHANGE_OTHER,
} from "./withdrawPageShared";
import { useWithdrawPage } from "./WithdrawPageContext";
import {
  countriesResidenceSelectOptions,
  withdrawSaveModalCountrySelectStyles,
} from "../../../utils/CountriesList";

function WithdrawSaveCountryDropdownIndicator(props) {
  return (
    <RSComponents.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-fill" aria-hidden="true" />
    </RSComponents.DropdownIndicator>
  );
}

const ADDR_BOOK_VERIFY_METHOD_ROWS = {
  email: {
    title: "Email",
    icon: "/images/email_vector2.svg",
  },
  mobile: {
    title: "Phone Number",
    icon: "/images/security/phone.svg",
  },
  google_authenticator: {
    title: "Authenticator App",
    icon: "/images/security/authenticator.svg",
  },
  passkey: {
    title: "Passkeys",
    icon: "/images/security/passkey.svg",
  },
};

export default function WithdrawPageSteps12() {
  /* eslint-disable no-unused-vars -- context exposes many fields; only subset used in this section */
  const {
    navigate,
    isMobile,
    setIsMobile,
    stepperWrapRef,
    railDims,
    setRailDims,
    withdrawSubmitting,
    setWithdrawSubmitting,
    emailVerifyCode,
    setEmailVerifyCode,
    withdrawOtpSending,
    setWithdrawOtpSending,
    withdrawOtpResendSec,
    setWithdrawOtpResendSec,
    withdrawWithdrawalFlowBusy,
    setWithdrawWithdrawalFlowBusy,
    withdrawConfirmBusy,
    setWithdrawConfirmBusy,
    withdrawSummaryContinueBusy,
    setWithdrawSummaryContinueBusy,
    withdrawalRequestLockRef,
    withdrawHistoryPromiseRef,
    selectedCoin,
    setSelectedCoin,
    withdrawCoins,
    setWithdrawCoins,
    loadingWithdrawCoins,
    setLoadingWithdrawCoins,
    coinSearchQuery,
    setCoinSearchQuery,
    recentWithdrawRows,
    setRecentWithdrawRows,
    loadingWithdrawHistory,
    setLoadingWithdrawHistory,
    fundMain,
    setFundMain,
    selectedWithdrawHistoryRow,
    setSelectedWithdrawHistoryRow,
    selectedNetwork,
    setSelectedNetwork,
    isWithdrawDetailsOpen,
    withdrawToTab,
    setWithdrawToTab,
    agceRecipientTab,
    setAgceRecipientTab,
    agceRecipientEmail,
    setAgceRecipientEmail,
    agceRecipientPhone,
    setAgceRecipientPhone,
    agceRecipientId,
    setAgceRecipientId,
    agceRecipientUsername,
    agceTouched,
    setAgceTouched,
    showAddressBookPanel,
    setShowAddressBookPanel,
    addressBookSubTab,
    setAddressBookSubTab,
    withdrawAddress,
    setWithdrawAddress,
    withdrawAddressTouched,
    setWithdrawAddressTouched,
    withdrawAddressValidError,
    setWithdrawAddressValidError,
    withdrawAddressValidatedKey,
    setWithdrawAddressValidatedKey,
    isWithdrawAddressValidating,
    setIsWithdrawAddressValidating,
    withdrawAddressValidationReqIdRef,
    withdrawAddrValidateDebounceTimerRef,
    withdrawConfirmProceedTimerRef,
    satoshiWhitelistConfirmInFlightRef,
    isAvailSourceOpen,
    setIsAvailSourceOpen,
    isAvailSourcePinned,
    setIsAvailSourcePinned,
    isAvailSourceContextLock,
    setIsAvailSourceContextLock,
    isNetworkFeeInfoOpen,
    setIsNetworkFeeInfoOpen,
    withdrawAmountInput,
    setWithdrawAmountInput,
    withdrawAmountTouched,
    setWithdrawAmountTouched,
    isLimitInfoOpen,
    setIsLimitInfoOpen,
    isWithdrawMetaRefreshing,
    setIsWithdrawMetaRefreshing,
    availSourceRef,
    phoneCountry,
    setPhoneCountry,
    isCountryOpen,
    setIsCountryOpen,
    countryRef,
    isWithdrawConfirmOpen,
    setIsWithdrawConfirmOpen,
    withdrawConfirmRef,
    isWithdrawSummaryOpen,
    setIsWithdrawSummaryOpen,
    withdrawSummaryRef,
    isPasskeyOpen,
    setIsPasskeyOpen,
    passkeyRef,
    isAuthAppOpen,
    setIsAuthAppOpen,
    authAppRef,
    authAppCode,
    setAuthAppCode,
    isChooseAuthOpen,
    setIsChooseAuthOpen,
    chooseAuthRef,
    isEmailVerifyOpen,
    setIsEmailVerifyOpen,
    emailVerifyRef,
    isMobileVerifyOpen,
    setIsMobileVerifyOpen,
    mobileVerifyRef,
    isSecUnavailableOpen,
    setIsSecUnavailableOpen,
    secUnavailable,
    setSecUnavailable,
    isSecResetConfirmOpen,
    setIsSecResetConfirmOpen,
    secResetAck,
    setSecResetAck,
    isSecReqOpen,
    setIsSecReqOpen,
    secReqDone,
    setSecReqDone,
    isRequestSubmittedOpen,
    setIsRequestSubmittedOpen,
    isSecurityResetSuccessOpen,
    setIsSecurityResetSuccessOpen,
    verificationContext,
    setVerificationContext,
    withdrawSecuritySettings,
    setWithdrawSecuritySettings,
    withdrawVerifyMethod,
    setWithdrawVerifyMethod,
    withdrawFundPassword,
    setWithdrawFundPassword,
    withdrawFundPasswordError,
    setWithdrawFundPasswordError,
    withdrawFundPasswordVisible,
    setWithdrawFundPasswordVisible,
    isNoMethodsModalOpen,
    setIsNoMethodsModalOpen,
    isWithdrawVerifyCombinedOpen,
    setIsWithdrawVerifyCombinedOpen,
    withdrawVerifyFieldErrors,
    setWithdrawVerifyFieldErrors,
    mobileVerifyCode,
    setMobileVerifyCode,
    withdrawOtpFallbackAfterPasskey,
    setWithdrawOtpFallbackAfterPasskey,
    closeAllOverlays,
    isAwaitingApprovalOpen,
    setIsAwaitingApprovalOpen,
    awaitingApprovalRef,
    isRecipientAmountOpen,
    setIsRecipientAmountOpen,
    recipientAmountRef,
    isSetPayPinOpen,
    setIsSetPayPinOpen,
    payPinDigits,
    setPayPinDigits,
    payPinShow,
    setPayPinShow,
    payPinRefs,
    isSaveAddressOpen,
    setIsSaveAddressOpen,
    saveAddrLabel,
    setSaveAddrLabel,
    saveAddrCoin,
    setSaveAddrCoin,
    saveAddrUniversal,
    setSaveAddrUniversal,
    saveAddrValue,
    setSaveAddrValue,
    saveAddrNetwork,
    setSaveAddrNetwork,
    saveAddrMemo,
    setSaveAddrMemo,
    saveAddrWhitelistMethod,
    setSaveAddrWhitelistMethod,
    saveAddrWizardStep,
    saveAddrOwnership,
    setSaveAddrOwnership,
    saveAddrWalletKindSelf,
    setSaveAddrWalletKindSelf,
    saveAddrWalletKindOther,
    setSaveAddrWalletKindOther,
    saveAddrExchangePick,
    setSaveAddrExchangePick,
    saveAddrExchangeManual,
    setSaveAddrExchangeManual,
    saveAddrDeclarationAccepted,
    setSaveAddrDeclarationAccepted,
    saveAddrBenFullName,
    setSaveAddrBenFullName,
    saveAddrBenPan,
    setSaveAddrBenPan,
    saveAddrBenCountry,
    setSaveAddrBenCountry,
    saveAddrBenPin,
    setSaveAddrBenPin,
    saveAddrBenAddress,
    setSaveAddrBenAddress,
    addressWhitelistFlow,
    setAddressWhitelistFlow,
    satoshiDepositAddress,
    setSatoshiDepositAddress,
    satoshiDepositMemo,
    setSatoshiDepositMemo,
    satoshiDepositLoading,
    setSatoshiDepositLoading,
    satoshiDepositError,
    setSatoshiDepositError,
    saveAddrSatoshiPolling,
    setSaveAddrSatoshiPolling,
    satoshiWhitelistAwaitingProof,
    setSatoshiWhitelistAwaitingProof,
    whitelistMetamaskBusy,
    setWhitelistMetamaskBusy,
    metamaskInstallModalOpen,
    setMetamaskInstallModalOpen,
    eip1193BrowserProviderDetected,
    setEip1193BrowserProviderDetected,
    saveAddrSubmitAttempted,
    setSaveAddrSubmitAttempted,
    saveAddrSaving,
    setSaveAddrSaving,
    saveAddrBasicsNextDisabled,
    saveAddrAddressValidating,
    saveAddrAddressValidError,
    validateSaveAddrBookAddress,
    saveAddrValidateDebounceTimerRef,
    clearSaveAddrAddressValidationForEdit,
    addressBookEntries,
    setAddressBookEntries,
    addressBookLoading,
    setAddressBookLoading,
    withdrawalAddressHistory,
    setWithdrawalAddressHistory,
    withdrawalAddressHistoryLoading,
    setWithdrawalAddressHistoryLoading,
    addressBookDeleteConfirm,
    setAddressBookDeleteConfirm,
    addressBookDeleteBusy,
    setAddressBookDeleteBusy,
    saveCoinMenuOpen,
    setSaveCoinMenuOpen,
    saveNetworkMenuOpen,
    setSaveNetworkMenuOpen,
    saveExchangeMenuOpen,
    setSaveExchangeMenuOpen,
    saveCoinSelectRef,
    saveNetworkSelectRef,
    saveExchangeSelectRef,
    isWithdrawHistoryDetailOpen,
    setIsWithdrawHistoryDetailOpen,
    hideWithdrawErrorNotices,
    setHideWithdrawErrorNotices,
    recentWithdrawTab,
    setRecentWithdrawTab,
    recentWithdrawRowsVisible,
    withdraw24hUsage,
    setWithdraw24hUsage,
    reloadWithdrawCatalog,
    reloadWithdrawal24hUsage,
    refetchWithdrawHistory,
    refetchAddressBook,
    refetchWithdrawalAddressHistory,
    payPinValue,
    isPayPinComplete,
    resetPayPin,
    handlePayPinDigit,
    handlePayPinKeyDown,
    isStep2Done,
    selectedCoinObj,
    isStep1Done,
    activeWithdrawNetworks,
    minWithdrawForSelection,
    effectiveAvailable,
    filteredWithdrawCoins,
    trendingWithdrawCoins,
    coinModalDisplay,
    coinQuickPickDisplay,
    saveAddrCoinOptionsList,
    saveAddrNetworkOptionsEffective,
    saveAddrChainCanonical,
    selectedCoinMeta,
    isWithdrawFormValid,
    withdrawAddressInlineError,
    withdrawAmountInlineError,
    summaryNetworkLabel,
    selectedTokenAssetId,
    validateCurrentWithdrawAddress,
    validateCurrentWithdrawAddressRef,
    applyWithdrawalAddressHistoryEntry,
    withdrawStep3Preview,
    getNonPasskeyEnabledMethods,
    hasConfigurableNonPasskeyMethods,
    withdrawCombinedVerificationReady,
    sendSingleWithdrawalOtp,
    withdrawOtpResendActive,
    submitWithdrawalWithEnabledMethods,
    handlePasskeyWithdrawFlow,
    handleWithdrawalSubmitFromCode,
    handleWithdrawalSubmitFundPassword,
    openWithdrawVerificationModal,
    openWithdrawOtpFallbackFromPasskey,
    openWithdrawVerificationCombinedOnly,
    shouldShowPasskeyLink,
    shouldShowSwitchMethodLink,
    openSecurityUnavailableFlow,
    openPasskeysOnlyRequirements,
    secUnavailableSelectedCount,
    secRequirementsMode,
    secReqTotal,
    secReqCompleted,
    agceErrors,
    handleAgceEmailChange,
    handleAgcePhoneChange,
    handleWithdrawMaxClick,
    handleWithdrawAmountChange,
    copyWithdrawText,
    pasteWithdrawAuthAppCode,
    onWithdrawAgainFromHistory,
    saveAddrErrors,
    isSaveAddrValid,
    saveAddrOtherIdentityErrors,
    saveAddrOwnershipError,
    saveAddrWalletKindSelfError,
    saveAddrWalletKindOtherError,
    saveAddrExchangeStepErrors,
    isSaveAddrSelfVerifyValid,
    saveAddrCoinDisplay,
    saveAddrNetworkDisplay,
    clearSatoshiWhitelistPoll,
    resetSaveAddressFormFields,
    handleWhitelistFlowBack,
    copySatoshiDepositAddress,
    copySatoshiDepositMemo,
    handleSatoshiWhitelistSent,
    handleMetaMaskWhitelistSign,
    resumeMetaMaskWhitelistFromAddressBook,
    resumeSatoshiWhitelistFromAddressBook,
    handleSaveAddressBookSubmit,
    saveAddrWizardBack,
    saveAddrWizardGoNext,
    handleSaveAddrExchangeStubSubmit,
    openFreshAddressBookWizard,
    openAddressBookDeleteConfirm,
    confirmAddressBookDelete,
    withdrawProfileReady,
    withdrawKycVerified,
    addrBookVerificationOptionsState,
    addrBookVerificationOptionsLoading,
    addrBookMaskedEmailDisplay,
    addrBookMaskedPhoneDisplay,
    addrBookWizardSelectedMethod,
    setAddrBookWizardSelectedMethod,
    confirmAddrBookWizardVerification,
  } = useWithdrawPage();
  /* eslint-enable no-unused-vars */

  const addrBookVerifyDisplayRows = useMemo(() => {
    const ids = addrBookVerificationOptionsState?.available_methods ?? [];
    return ids
      .map((id) => {
        const meta = ADDR_BOOK_VERIFY_METHOD_ROWS[id];
        if (!meta) return null;
        const sub =
          id === "email"
            ? addrBookMaskedEmailDisplay || ""
            : id === "mobile"
              ? addrBookMaskedPhoneDisplay || ""
              : "";
        return { id, title: meta.title, icon: meta.icon, sub };
      })
      .filter(Boolean);
  }, [addrBookVerificationOptionsState, addrBookMaskedEmailDisplay, addrBookMaskedPhoneDisplay]);

  return (
    <>
      <div className="deposit_step_section select_coin_option select-option">
        <div className="deposit_step_header">
          <StepBadge step={1} done={isStep1Done} />
          <h2>Select Coin</h2>
        </div>
        <div className="search_icon_s d-flex items-center justify-content-between" data-bs-toggle="modal" data-bs-target="#search_coin">
          <div className="search_icon_s_inner">
            <i className="ri-search-line" />{" "}
            {loadingWithdrawCoins ? (
              <span>Loading coins…</span>
            ) : selectedCoinObj ? (
              <>
                <span style={{ display: "inline-flex", alignItems: "center", marginRight: 8 }}>
                  <WithdrawCoinThumb coin={selectedCoinObj} size={22} />
                </span>
                <span>{selectedCoin}</span> {selectedCoinMeta.name}
              </>
            ) : (
              <span>{SELECT_COIN_PLACEHOLDER}</span>
            )}
          </div>{" "}
          <span>
            <i className="ri-arrow-down-s-line"></i>
          </span>
        </div>

        <div className="modal search_form search_coin search_form_modal_2" id="search_coin" tabIndex="-1" aria-labelledby="exampleModalLabel">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Select Coin</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <input
                    type="text"
                    className="searchfield"
                    placeholder="Search coin"
                    value={coinSearchQuery}
                    onChange={(e) => setCoinSearchQuery(e.target.value)}
                  />
                </form>

                <div className="hot_trading_t">
                  <table>
                    <tbody>
                      {loadingWithdrawCoins ? (
                        <tr>
                          <td colSpan={2}>Loading…</td>
                        </tr>
                      ) : filteredWithdrawCoins.length === 0 ? (
                        <tr>
                          <td colSpan={2}>No coins available</td>
                        </tr>
                      ) : (
                        coinModalDisplay.map((c) => {
                          const sym = coinSymbol(c);
                          const isSelected = String(selectedCoin).toUpperCase() === sym.toUpperCase();
                          return (
                            <tr
                              key={c._id || sym}
                              data-bs-dismiss="modal"
                              onClick={() => {
                                setSelectedCoin(sym.toUpperCase());
                                setCoinSearchQuery("");
                              }}
                              className={isSelected ? "is-selected" : undefined}
                            >
                              <td>
                                <div className="td_first">
                                  <div className="icon">
                                    <WithdrawCoinThumb coin={c} size={30} />
                                  </div>
                                  <div className="price_heading">
                                    {sym.toUpperCase()} <br />
                                    <span>{c.name || sym}</span>
                                  </div>
                                </div>
                              </td>
                              <td className="right_t price_tb">
                                <div className="price_tb_inner">
                                  {coinWithdrawListHint(c)}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="coin_items_select">
          {(loadingWithdrawCoins ? [] : coinQuickPickDisplay).map((c) => {
            const sym = coinSymbol(c);
            const isSelected = String(selectedCoin).toUpperCase() === sym.toUpperCase();
            return (
              <div
                key={c._id || sym}
                className={`coin_items_list${isSelected ? " is-selected" : ""}`}
                onClick={() => setSelectedCoin(sym.toUpperCase())}
              >
                <WithdrawCoinThumb coin={c} size={24} />
                {sym.toUpperCase()}
              </div>
            );
          })}
        </div>
      </div>

      <div className="deposit_step_section select_network_s select-option">
        <div className="deposit_step_header">
          <StepBadge step={2} done={isStep2Done} />
          <h2>Withdraw to</h2>
        </div>

        <div className="withdral_bl_inner">
          <div className="address_user_tp">
            <ul role="tablist" aria-label="Withdraw to">
              <li role="presentation">
                <button
                  type="button"
                  role="tab"
                  className={withdrawToTab === "address" ? "is-active" : undefined}
                  aria-selected={withdrawToTab === "address"}
                  onClick={() => setWithdrawToTab("address")}
                >
                  Address
                </button>
              </li>
              {/* <li role="presentation">
                <button
                  type="button"
                  role="tab"
                  className={withdrawToTab === "agce_user" ? "is-active" : undefined}
                  aria-selected={withdrawToTab === "agce_user"}
                  onClick={() => setWithdrawToTab("agce_user")}
                >
                  AGCX User
                </button>
              </li> */}
            </ul>
          </div>

          {withdrawToTab === "address" ? (
            <>
              <div
                className="search_icon_s d-flex items-center justify-content-between"
                data-bs-toggle="modal"
                data-bs-target="#network_pop_up"
                role="button"
                tabIndex={0}
              >
                <span className="withdraw_to_network_val">{selectedNetwork || "Select Network"}</span>
                <span className="withdraw_chev">
                  <i className="ri-arrow-down-s-line" aria-hidden="true" />
                </span>
              </div>

              <div className={`search_icon_s user_address_fill d-flex items-center justify-content-between mt-3${withdrawAddressInlineError ? " has-error" : ""}`}>
                <div className="search_icon_s_inner addressfill">
                  <input
                    type="text"
                    placeholder="Enter Address"
                    value={withdrawAddress}
                    onChange={(e) => {
                      setWithdrawAddress(e.target.value);
                      if (!withdrawAddressTouched) setWithdrawAddressTouched(true);
                      setWithdrawAddressValidError("");
                      setWithdrawAddressValidatedKey("");
                    }}
                    onBlur={async () => {
                      setWithdrawAddressTouched(true);
                      if (withdrawAddrValidateDebounceTimerRef.current) {
                        clearTimeout(withdrawAddrValidateDebounceTimerRef.current);
                        withdrawAddrValidateDebounceTimerRef.current = null;
                      }
                      await validateCurrentWithdrawAddress();
                    }}
                    aria-invalid={Boolean(withdrawAddressInlineError)}
                  />
                </div>
                <span>
                  <button
                    type="button"
                    className="user_address_fill_btn"
                    aria-expanded={showAddressBookPanel}
                    aria-controls="withdraw-address-book-panel"
                    onClick={() => setShowAddressBookPanel((open) => !open)}
                  >
                    <img src="/images/user_withdarwal.svg" alt="" />
                  </button>
                </span>
              </div>
              {withdrawAddressInlineError ? (
                <div className="withdraw_inline_error" role="alert">
                  {withdrawAddressInlineError}
                </div>
              ) : isWithdrawAddressValidating ? (
                <div className="withdraw_inline_loader" role="status" aria-live="polite">
                  Validating address...
                </div>
              ) : withdrawAddressValidError ? (
                <div className="withdraw_inline_error" role="alert">
                  {withdrawAddressValidError}
                </div>
              ) : null}

              {showAddressBookPanel ? (
                <div
                  id="withdraw-address-book-panel"
                  className="withdraw_address_book_stack"
                  role="region"
                  aria-label="Address book"
                >


                  <div className="withdraw_ab_maincard">
                    <div className="withdraw_ab_card_head d-flex items-center justify-content-between flex-wrap gap-2">
                      <div className="withdraw_ab_tabs" role="tablist" aria-label="Address book tabs">
                        <button
                          type="button"
                          role="tab"
                          className={
                            addressBookSubTab === "history"
                              ? "withdraw_ab_tab is-active is-accent"
                              : "withdraw_ab_tab"
                          }
                          aria-selected={addressBookSubTab === "history"}
                          onClick={() => setAddressBookSubTab("history")}
                        >
                          Recent
                        </button>
                        <button
                          type="button"
                          role="tab"
                          className={
                            addressBookSubTab === "my_address"
                              ? "withdraw_ab_tab is-active is-muted"
                              : "withdraw_ab_tab"
                          }
                          aria-selected={addressBookSubTab === "my_address"}
                          onClick={() => setAddressBookSubTab("my_address")}
                        >
                          My Address
                        </button>
                      </div>

                    </div>

                    {addressBookSubTab === "my_address" ? (
                      <div className="withdraw_ab_body withdraw_ab_body_saved">
                        <button
                          type="button"
                          className="withdraw_ab_edit_btn"
                          aria-label="Add address"
                          onClick={() => openFreshAddressBookWizard()}
                        >
                          <img src="/images/edit_icon3.svg" alt="add address" />
                        </button>
                        {addressBookLoading ? (
                          <div className="withdraw_ab_addr_hint">Loading addresses…</div>
                        ) : addressBookEntries.length === 0 ? (
                          <div className="withdraw_ab_addr_hint">No saved addresses. Save one from the form below.</div>
                        ) : (
                          <div className="withdraw_ab_saved_list">
                            {addressBookEntries.map((entry) => {
                              const eid = entry._id || entry.id;
                              const addr = entry.address || "";
                              const shortAddr = addr ? truncateMid(addr, 8, 6) : "—";
                              const canUseForWithdraw = addressBookEntryWithdrawable(entry);
                              const pendingMetaMaskSign = addressBookEntryPendingMetaMaskSignature(entry);
                              const pendingSatoshiDeposit = addressBookEntryPendingSatoshiDeposit(entry);
                              const statusLabel = addressBookStatusBadgeLabel(entry);
                              const statusTone = statusLabel ? withdrawStatusTone(statusLabel) : "neutral";
                              const rowInteractive =
                                canUseForWithdraw || pendingMetaMaskSign || pendingSatoshiDeposit;
                              const rowHasNestedAction = pendingMetaMaskSign || pendingSatoshiDeposit;
                              const applyFromBook = () => {
                                setWithdrawAddress(addr);
                                setWithdrawAddressTouched(true);
                                setWithdrawAddressValidError("");
                                setWithdrawAddressValidatedKey("");
                                setShowAddressBookPanel(false);
                                window.setTimeout(() => {
                                  void validateCurrentWithdrawAddressRef.current?.();
                                }, 0);
                              };
                              return (
                                <div
                                  key={eid || addr}
                                  className={`withdraw_ab_saved_row${!canUseForWithdraw ? " withdraw_ab_saved_row--pending" : ""}`}
                                  role={rowHasNestedAction ? undefined : rowInteractive ? "button" : undefined}
                                  tabIndex={rowHasNestedAction ? -1 : rowInteractive ? 0 : -1}
                                  onClick={() => {
                                    if (pendingMetaMaskSign) {
                                      resumeMetaMaskWhitelistFromAddressBook(entry);
                                      return;
                                    }
                                    if (pendingSatoshiDeposit) {
                                      resumeSatoshiWhitelistFromAddressBook(entry);
                                      return;
                                    }
                                    if (!canUseForWithdraw) {
                                      alertErrorMessage(
                                        "Only approved addresses can be used for withdrawal. This entry is still pending or was rejected."
                                      );
                                      return;
                                    }
                                    applyFromBook();
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key !== "Enter" && e.key !== " ") return;
                                    e.preventDefault();
                                    if (pendingMetaMaskSign) {
                                      resumeMetaMaskWhitelistFromAddressBook(entry);
                                      return;
                                    }
                                    if (pendingSatoshiDeposit) {
                                      resumeSatoshiWhitelistFromAddressBook(entry);
                                      return;
                                    }
                                    if (!canUseForWithdraw) {
                                      alertErrorMessage(
                                        "Only approved addresses can be used for withdrawal. This entry is still pending or was rejected."
                                      );
                                      return;
                                    }
                                    applyFromBook();
                                  }}
                                >
                                  <div className="withdraw_ab_saved_row_top">
                                    <span className="withdraw_ab_saved_label">{entry.label || "Saved"}</span>
                                    {entry.chain ? (
                                      <span className="withdraw_ab_network_tag">{String(entry.chain).toUpperCase()}</span>
                                    ) : null}
                                    {statusLabel ? (
                                      <span
                                        className={`withdraw_ab_status withdraw_ab_status--${statusTone}`}
                                        title={entry.coin ? `${entry.coin} · ${statusLabel}` : statusLabel}
                                      >
                                        {statusLabel}
                                      </span>
                                    ) : null}
                                    <button
                                      type="button"
                                      className="withdraw_ab_saved_remove"
                                      aria-label="Remove address"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openAddressBookDeleteConfirm(entry);
                                      }}
                                    >
                                      ×
                                    </button>
                                  </div>
                                  <div className="withdraw_ab_addr_text withdraw_ab_saved_addr_mono">{shortAddr}</div>
                                  {pendingSatoshiDeposit ? (
                                    <button
                                      type="button"
                                      className="withdraw_ab_resume_mm_btn withdraw_ab_resume_satoshi_btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        resumeSatoshiWhitelistFromAddressBook(entry);
                                      }}
                                    >
                                      Show deposit QR & amount
                                    </button>
                                  ) : null}
                                  {pendingMetaMaskSign ? (
                                    <button
                                      type="button"
                                      className="withdraw_ab_resume_mm_btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        resumeMetaMaskWhitelistFromAddressBook(entry);
                                      }}
                                    >
                                      Sign with MetaMask to complete
                                    </button>
                                  ) : null}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="withdraw_ab_body withdraw_ab_body_history">
                        <div className="withdraw_ab_history_panel">
                          <div className="withdraw_ab_history_top d-flex items-center justify-content-between flex-wrap gap-2">
                            <span className="withdraw_ab_history_hint">
                            Your recently used withdrawal addresses. Select an address to use it again.
                            </span>
                            <button
                              type="button"
                              className="withdraw_ab_save_link"
                              onClick={() => openFreshAddressBookWizard()}
                            >
                              Save address
                            </button>
                          </div>
                          {withdrawalAddressHistoryLoading ? (
                            <div className="withdraw_ab_addr_hint" role="status">
                              Loading recent addresses…
                            </div>
                          ) : withdrawalAddressHistory.length === 0 ? (
                            <div className="withdraw_ab_addr_hint">No recent withdrawal addresses yet.</div>
                          ) : (
                            <div className="withdraw_ab_saved_list withdraw_ab_hist_list">
                              {withdrawalAddressHistory.map((entry) => {
                                const addr = String(entry.address || "").trim();
                                const shortAddr = addr ? truncateMid(addr, 8, 6) : "—";
                                const coin = String(entry.coin || "").toUpperCase() || "—";
                                const chain = String(entry.chain || "").toUpperCase() || "—";
                                const used =
                                  entry.times_used != null && entry.times_used !== ""
                                    ? Number(entry.times_used)
                                    : null;
                                const lastAt = formatWithdrawAddressHistoryDate(entry.last_used_at);
                                const statusRaw =
                                  entry.last_status != null ? String(entry.last_status).toUpperCase() : "";
                                const listKey = `${addr}|${coin}|${chain}|${String(entry.fireblocks_asset_id || "")}`;
                                return (
                                  <div
                                    key={listKey}
                                    className="withdraw_ab_saved_row withdraw_ab_hist_row"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => applyWithdrawalAddressHistoryEntry(entry)}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Enter" && e.key !== " ") return;
                                      e.preventDefault();
                                      applyWithdrawalAddressHistoryEntry(entry);
                                    }}
                                  >
                                    <div className="withdraw_ab_saved_row_top">
                                      <span className="withdraw_ab_saved_label">{coin}</span>
                                      <span className="withdraw_ab_network_tag">{chain}</span>
                                      {statusRaw ? (
                                        <span
                                          className={`withdraw_ab_status withdraw_ab_status--${withdrawStatusTone(statusRaw)}`}
                                        >
                                          {statusRaw.replace(/_/g, " ")}
                                        </span>
                                      ) : null}
                                    </div>
                                    <div className="withdraw_ab_addr_text withdraw_ab_saved_addr_mono">{shortAddr}</div>
                                    <div className="withdraw_ab_hist_meta">
                                      {Number.isFinite(used) && used > 0 ? (
                                        <span>Used {used}×</span>
                                      ) : null}
                                      {lastAt ? (
                                        <span>
                                          {Number.isFinite(used) && used > 0 ? " · " : null}
                                          Last: {lastAt}
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </>
          ) : (
            <>
              <div className="agce_recipient_tp" role="tablist" aria-label="Recipient type">
                <button
                  type="button"
                  role="tab"
                  className={agceRecipientTab === "email" ? "is-active" : undefined}
                  aria-selected={agceRecipientTab === "email"}
                  onClick={() => {
                    setAgceRecipientTab("email");
                    setAgceTouched((p) => ({ ...p, phone: false }));
                  }}
                >
                  Email
                </button>
                <button
                  type="button"
                  role="tab"
                  className={agceRecipientTab === "phone" ? "is-active" : undefined}
                  aria-selected={agceRecipientTab === "phone"}
                  onClick={() => {
                    setAgceRecipientTab("phone");
                    setAgceTouched((p) => ({ ...p, email: false }));
                  }}
                >
                  Phone
                </button>
                <button
                  type="button"
                  role="tab"
                  className={agceRecipientTab === "agce" ? "is-active" : undefined}
                  aria-selected={agceRecipientTab === "agce"}
                  onClick={() => {
                    setAgceRecipientTab("agce");
                    setAgceTouched({ email: false, phone: false });
                  }}
                >
                  AGCX User
                </button>
              </div>

              {agceRecipientTab === "email" ? (
                <div className="withdraw_agce_input_wrap mt-3">
                  <EmailInputWithDomainSuggest
                    name="agce-recipient-email"
                    autoComplete="off"
                    placeholder="Recipient's email"
                    value={agceRecipientEmail}
                    onChange={handleAgceEmailChange}
                    onBlur={(e) => {
                      const t = (e?.target?.value || "").trim();
                      if (t) setAgceTouched((p) => ({ ...p, email: true }));
                    }}
                    inputClassName={agceErrors.email ? "is-invalid" : ""}
                    wrapClassName="eids-email-wrap"
                  />
                  {agceErrors.email ? <div className="withdraw_field_error">{agceErrors.email}</div> : null}
                </div>
              ) : null}
              {agceRecipientTab === "phone" ? (
                <div className="withdraw_agce_input_wrap mt-3">
                  <div className={`withdraw_agce_phone_row${agceErrors.phone ? " is-invalid" : ""}`} ref={countryRef}>
                    <button
                      type="button"
                      className="withdraw_country_btn"
                      aria-label="Country code"
                      aria-expanded={isCountryOpen}
                      onClick={() => setIsCountryOpen((v) => !v)}
                    >
                      <span className="withdraw_country_flag" aria-hidden="true">
                        {phoneCountry.flag}
                      </span>
                      <span className="withdraw_country_code">{phoneCountry.code}</span>
                      <i className="ri-arrow-down-s-line" aria-hidden="true" />
                    </button>

                    {isCountryOpen ? (
                      <div className="withdraw_country_menu" role="listbox" aria-label="Select country code">
                        {[
                          { flag: "🇮🇳", code: "+91", label: "India" },
                          { flag: "🇦🇪", code: "+971", label: "UAE" },
                          { flag: "🇸🇦", code: "+966", label: "Saudi Arabia" },
                          { flag: "🇺🇸", code: "+1", label: "United States" },
                          { flag: "🇬🇧", code: "+44", label: "United Kingdom" },
                        ].map((c) => (
                          <button
                            key={c.code}
                            type="button"
                            className="withdraw_country_item"
                            role="option"
                            aria-selected={phoneCountry.code === c.code}
                            onClick={() => {
                              setPhoneCountry({ flag: c.flag, code: c.code });
                              setIsCountryOpen(false);
                            }}
                          >
                            <span className="withdraw_country_item_flag" aria-hidden="true">
                              {c.flag}
                            </span>
                            <span className="withdraw_country_item_code">{c.code}</span>
                            <span className="withdraw_country_item_label">{c.label}</span>
                          </button>
                        ))}
                      </div>
                    ) : null}
                    <input
                      type="tel"
                      name="agce-recipient-phone"
                      autoComplete="off"
                      placeholder="Recipient's phone number"
                      value={agceRecipientPhone}
                      onChange={handleAgcePhoneChange}
                      onBlur={(e) => {
                        const t = e.target.value.trim();
                        if (t) setAgceTouched((p) => ({ ...p, phone: true }));
                      }}
                    />
                  </div>
                  {agceErrors.phone ? <div className="withdraw_field_error">{agceErrors.phone}</div> : null}
                </div>
              ) : null}
              {agceRecipientTab === "agce" ? (
                <>
                  <div className="withdraw_agce_input_wrap mt-3">
                    <input
                      type="text"
                      name="agce-recipient-id"
                      autoComplete="off"
                      placeholder="Recipient's AGCX username or UID"
                      value={agceRecipientId}
                      onChange={(e) => setAgceRecipientId(e.target.value)}
                    />
                  </div>
                  <span className="payee_text">Payee can find AGCX ID under Top - right Avatar - Dashboard</span>
                </>
              ) : null}

            </>
          )}
        </div>
        {/* <p>
                Ensure that the selected deposit network is the same as the withdrawal
                 network. Otherwise, you'll not be able to withdraw later. Want help to choose a network?
                </p> */}

        <div className="modal search_form search_coin" id="network_pop_up" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="deposit_select_network_head withdraw_select_network_head">
                <div className="modal-header">
                  <h5>Select Network</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
              </div>
              <div className="modal-body">
                <div className="network_top_p">
                  <svg className="bn-svg h-m w-m flex-shrink-0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 21a9 9 0 100-18 9 9 0 000 18zm-1.25-5.5V18h2.5v-2.5h-2.5zm0-9.5v7h2.5V6h-2.5z"
                      fill="currentColor"
                    ></path>
                  </svg>
                  <p>Only supported networks on the AGCX platform are shown. If you provide an address from an unsupported network, your withdrawal request may be rejected. </p>
                </div>

                <div className="hot_trading_t">
                  <table>
                    <tbody>
                      {!selectedCoinObj ? (
                        <tr>
                          <td colSpan={2}>Select a coin first</td>
                        </tr>
                      ) : activeWithdrawNetworks.length === 0 ? (
                        <tr>
                          <td colSpan={2}>No networks available for this asset</td>
                        </tr>
                      ) : (
                        activeWithdrawNetworks.map((n) => (
                          <tr
                            key={n.code}
                            data-bs-dismiss="modal"
                            onClick={() => { setSelectedNetwork(n.code); setWithdrawAddressValidError(""); setWithdrawAddressValidatedKey(""); }}
                          >
                            <td>
                              <div className="td_first">
                                <div className="price_heading">
                                  {" "}
                                  {n.code}
                                  <br /> <span>{n.label}</span>
                                </div>
                              </div>
                            </td>
                            <td className="right_t price_tb">
                              {n.min} - {n.max} {selectedCoin}
                              <br />
                              <span>{n.eta}</span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isSaveAddressOpen ? (
        <div className="withdraw_confirm_overlay" role="presentation">
          <div
            className="withdraw_save_modal verify_identity"
            role="dialog"
            aria-modal="true"
            aria-labelledby="withdraw_save_title"
          >
            <button
              type="button"
              className="withdraw_confirm_close"
              aria-label="Close"
              onClick={() => {
                setIsSaveAddressOpen(false);
                resetSaveAddressFormFields();
              }}
            >
              ×
            </button>

            <div className="withdraw_save_head">
              <h2 id="withdraw_save_title" className="withdraw_save_title">
                {addressWhitelistFlow
                  ? "Verify withdrawal address"
                  : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.BASICS
                    ? "Add withdrawal address"
                    : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.VERIFY_ACCOUNT
                      ? "Verify your identity"
                      : "Address confirmation"}
              </h2>
            </div>

            {addressWhitelistFlow?.type === "satoshi" ? (
              <>
                <div className="withdraw_save_body">
                  <div className="withdraw_whitelist_step">
                    <p className="withdraw_whitelist_intro">
                      To verify ownership of this address, send exactly:
                    </p>
                    <p className="withdraw_whitelist_amount">
                      {addressWhitelistFlow.proof_amount} {addressWhitelistFlow.proof_asset} (
                      {addressWhitelistFlow.proof_chain})
                    </p>
                    <p className="withdraw_whitelist_hint">
                      The deposit must come from the address you are whitelisting. Send this micro-amount
                      to your AGCX deposit address for {addressWhitelistFlow.proof_asset} (
                      {addressWhitelistFlow.proof_chain}). Scan the QR code below or copy the address.
                    </p>
                    {satoshiDepositLoading ? (
                      <div className="withdraw_whitelist_deposit_loading" role="status">
                        <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
                        Loading your deposit address…
                      </div>
                    ) : satoshiDepositError ? (
                      <div className="withdraw_save_error" role="alert">
                        {satoshiDepositError}{" "}
                        <Link className="withdraw_whitelist_link" to="/asset_managemnet/deposit">
                          Open Deposit
                        </Link>
                      </div>
                    ) : satoshiDepositAddress ? (
                      <div className="withdraw_whitelist_deposit_panel">
                        <div className="withdraw_whitelist_qr_wrap">
                          <QRCodeSVG
                            value={satoshiDepositAddress}
                            size={160}
                            includeMargin
                            className="withdraw_whitelist_qr_svg"
                          />
                          <div className="withdraw_whitelist_qr_hint">Scan to deposit</div>
                        </div>
                        <div className="withdraw_whitelist_deposit_fields">
                          <div className="withdraw_whitelist_addr_block">
                            <span className="withdraw_whitelist_field_label">Your AGCX deposit address</span>
                            <div className="withdraw_whitelist_addr_input_row">
                              <input
                                type="text"
                                readOnly
                                className="withdraw_save_input"
                                value={satoshiDepositAddress}
                              />
                              <button
                                type="button"
                                className="withdraw_whitelist_copy_btn"
                                onClick={copySatoshiDepositAddress}
                              >
                                Copy
                              </button>
                            </div>
                          </div>
                          {satoshiDepositMemo && String(satoshiDepositMemo).trim() ? (
                            <div className="withdraw_whitelist_addr_block">
                              <span className="withdraw_whitelist_field_label">Memo (Tag)</span>
                              <div className="withdraw_whitelist_addr_input_row">
                                <input
                                  type="text"
                                  readOnly
                                  className="withdraw_save_input"
                                  value={satoshiDepositMemo}
                                />
                                <button
                                  type="button"
                                  className="withdraw_whitelist_copy_btn"
                                  onClick={copySatoshiDepositMemo}
                                >
                                  Copy
                                </button>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                    <p className="withdraw_whitelist_expiry">
                      ⏱ You have 24 hours. Expires: {formatWhitelistExpiry(addressWhitelistFlow.expires_at)}
                    </p>
                    {saveAddrSatoshiPolling ? (
                      <div className="withdraw_whitelist_checking" role="status">
                        <WithdrawButtonSpinner />
                        <span className="withdraw_whitelist_checking_text">Checking with server…</span>
                      </div>
                    ) : null}
                    {satoshiWhitelistAwaitingProof ? (
                      <div className="withdraw_whitelist_awaiting_notice" role="status">
                        <p className="withdraw_whitelist_awaiting_title">Deposit not confirmed yet</p>
                        <p className="withdraw_whitelist_awaiting_body">
                          Your micro-deposit can take time to arrive and for our systems to detect it.
                        </p>
                        <p className="withdraw_whitelist_awaiting_body">
                          You may close this dialog and watch the entry under{" "}
                          <strong>My Address</strong> in your address book. When it is approved you can use
                          it for withdrawals. Use <strong>Check again</strong> below to ask the server once
                          more.
                        </p>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="withdraw_save_actions">
                  <button
                    type="button"
                    className="withdraw_save_btn withdraw_save_btn--cancel"
                    disabled={saveAddrSatoshiPolling}
                    onClick={handleWhitelistFlowBack}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="withdraw_save_btn withdraw_save_btn--save"
                    disabled={saveAddrSatoshiPolling}
                    onClick={() => void handleSatoshiWhitelistSent()}
                  >
                    {saveAddrSatoshiPolling
                      ? "Checking…"
                      : satoshiWhitelistAwaitingProof
                        ? "Check again"
                        : "I've sent the payment"}
                  </button>
                </div>
              </>
            ) : addressWhitelistFlow?.type === "metamask" ? (
              <>
                <div className="withdraw_save_body">
                  <div className="withdraw_whitelist_step">
                    <p className="withdraw_whitelist_intro">
                      Sign the verification message with MetaMask using the same wallet as the address
                      above.
                    </p>
                    <p className="withdraw_whitelist_hint">
                      Use <strong>Sign with MetaMask</strong> to connect and sign. If the MetaMask
                      extension is not installed or not enabled for this site, you will get steps to add
                      it.
                    </p>
                    {!eip1193BrowserProviderDetected ? (
                      <p className="withdraw_whitelist_mm_soft_hint" role="status">
                        MetaMask is not detected yet on this page. If you just installed it, try the
                        button below or refresh the page.
                      </p>
                    ) : null}
                    <p className="withdraw_whitelist_expiry">
                      Expires: {formatWhitelistExpiry(addressWhitelistFlow.expires_at)}
                    </p>
                  </div>
                </div>
                <div className="withdraw_save_actions">
                  <button
                    type="button"
                    className="withdraw_save_btn withdraw_save_btn--cancel"
                    disabled={whitelistMetamaskBusy}
                    onClick={handleWhitelistFlowBack}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="withdraw_save_btn withdraw_save_btn--save"
                    disabled={whitelistMetamaskBusy}
                    onClick={() => void handleMetaMaskWhitelistSign()}
                  >
                    {whitelistMetamaskBusy ? "Signing…" : "Sign with MetaMask"}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="withdraw_save_body">
                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.BASICS ? (
                    <>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_addr_label">
                          Label
                        </label>
                        <input
                          id="withdraw_save_addr_label"
                          className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrErrors.label ? " is-invalid" : ""
                            }`}
                          type="text"
                          placeholder={"4-20 characters"}
                          value={saveAddrLabel}
                          onChange={(e) => setSaveAddrLabel(e.target.value)}
                        />
                        {saveAddrSubmitAttempted && saveAddrErrors.label ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrErrors.label}
                          </div>
                        ) : null}
                      </div>

                      <div className="withdraw_save_field">
                        <div className="withdraw_save_label" id="withdraw_save_coin_label">
                          Asset
                        </div>
                        <div
                          className={`withdraw_save_select_wrap${saveCoinMenuOpen ? " is-open" : ""}`}
                          ref={saveCoinSelectRef}
                        >
                          <button
                            type="button"
                            id="withdraw_save_coin"
                            className={`withdraw_save_select_trigger${!saveAddrCoin ? " is-placeholder" : ""}${saveAddrSubmitAttempted && saveAddrErrors.coin ? " is-invalid" : ""
                              }`}
                            aria-haspopup="listbox"
                            aria-expanded={saveCoinMenuOpen}
                            aria-labelledby="withdraw_save_coin_label"
                            onClick={() => {
                              setSaveNetworkMenuOpen(false);
                              setSaveExchangeMenuOpen(false);
                              setSaveCoinMenuOpen((o) => !o);
                            }}
                          >
                            <span className="withdraw_save_select_value">
                              {saveAddrCoinDisplay || "Select Coin"}
                            </span>
                          </button>
                          {saveCoinMenuOpen ? (
                            <ul className="withdraw_save_select_menu" role="listbox" aria-labelledby="withdraw_save_coin_label">
                              {saveAddrCoinOptionsList.map((opt) => (
                                <li key={opt.value} role="none">
                                  <button
                                    type="button"
                                    role="option"
                                    aria-selected={saveAddrCoin === opt.value}
                                    className={`withdraw_save_select_option${saveAddrCoin === opt.value ? " is-selected" : ""}`}
                                    onClick={() => {
                                      setSaveAddrCoin(opt.value);
                                      setSaveCoinMenuOpen(false);
                                    }}
                                  >
                                    {opt.label}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          ) : null}
                        </div>
                        {saveAddrSubmitAttempted && saveAddrErrors.coin ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrErrors.coin}
                          </div>
                        ) : null}
                      </div>

                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_wallet">
                          Address
                        </label>
                        <input
                          id="withdraw_save_wallet"
                          className={`withdraw_save_input${(saveAddrSubmitAttempted && saveAddrErrors.address) || saveAddrAddressValidError
                            ? " is-invalid"
                            : ""
                            }`}
                          type="text"
                          placeholder="Enter wallet address"
                          value={saveAddrValue}
                          onChange={(e) => {
                            setSaveAddrValue(e.target.value);
                            clearSaveAddrAddressValidationForEdit();
                          }}
                          onBlur={async () => {
                            if (saveAddrValidateDebounceTimerRef.current) {
                              clearTimeout(saveAddrValidateDebounceTimerRef.current);
                              saveAddrValidateDebounceTimerRef.current = null;
                            }
                            await validateSaveAddrBookAddress();
                          }}
                          autoComplete="off"
                        />
                        {saveAddrSubmitAttempted && saveAddrErrors.address ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrErrors.address}
                          </div>
                        ) : saveAddrAddressValidating ? (
                          <div className="withdraw_inline_loader" role="status" aria-live="polite">
                            Validating address…
                          </div>
                        ) : saveAddrAddressValidError ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrAddressValidError}
                          </div>
                        ) : null}
                      </div>

                      <div className="withdraw_save_field">
                        <div className="withdraw_save_label" id="withdraw_save_network_label">
                          Network
                        </div>
                        <div
                          className={`withdraw_save_select_wrap${saveNetworkMenuOpen ? " is-open" : ""}`}
                          ref={saveNetworkSelectRef}
                        >
                          <button
                            type="button"
                            id="withdraw_save_network"
                            className={`withdraw_save_select_trigger${!saveAddrNetwork ? " is-placeholder" : ""}${saveAddrSubmitAttempted && saveAddrErrors.network ? " is-invalid" : ""
                              }`}
                            aria-haspopup="listbox"
                            aria-expanded={saveNetworkMenuOpen}
                            aria-labelledby="withdraw_save_network_label"
                            onClick={() => {
                              setSaveCoinMenuOpen(false);
                              setSaveExchangeMenuOpen(false);
                              setSaveNetworkMenuOpen((o) => !o);
                            }}
                          >
                            <span className="withdraw_save_select_value">
                              {saveAddrNetworkDisplay || "Select Network"}
                            </span>
                          </button>
                          {saveNetworkMenuOpen ? (
                            <ul
                              className="withdraw_save_select_menu"
                              role="listbox"
                              aria-labelledby="withdraw_save_network_label"
                            >
                              {saveAddrNetworkOptionsEffective.map((opt) => (
                                <li key={opt.value} role="none">
                                  <button
                                    type="button"
                                    role="option"
                                    aria-selected={saveAddrNetwork === opt.value}
                                    className={`withdraw_save_select_option${saveAddrNetwork === opt.value ? " is-selected" : ""
                                      }`}
                                    onClick={() => {
                                      setSaveAddrNetwork(opt.value);
                                      setSaveNetworkMenuOpen(false);
                                    }}
                                  >
                                    {opt.label}
                                  </button>
                                </li>
                              ))}
                            </ul>
                          ) : null}
                        </div>
                        {saveAddrSubmitAttempted && saveAddrErrors.network ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrErrors.network}
                          </div>
                        ) : null}
                      </div>

                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_memo">
                          Memo / Tag (optional)
                        </label>
                        <input
                          id="withdraw_save_memo"
                          className="withdraw_save_input"
                          type="text"
                          placeholder="e.g. XRP destination tag"
                          value={saveAddrMemo}
                          onChange={(e) => setSaveAddrMemo(e.target.value)}
                        />
                      </div>
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OWNER ? (
                    <>
                      <p className="withdraw_save_confirm_lead">
                        Please provide the details of the address owner (the person you are transacting with).
                        These details will be used to comply with regulatory requirements when transacting with
                        this address.
                      </p>
                      <div className="withdraw_save_radio_block">
                        <p className="withdraw_save_radio_question" id="withdraw_save_owner_question">
                          Who does this address belong to?
                        </p>
                        <div
                          className="withdraw_save_radio_rows"
                          role="radiogroup"
                          aria-labelledby="withdraw_save_owner_question"
                        >
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_ownership"
                              checked={saveAddrOwnership === "SELF"}
                              onChange={() => setSaveAddrOwnership("SELF")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">Myself</span>
                          </label>
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_ownership"
                              checked={saveAddrOwnership === "OTHER"}
                              onChange={() => setSaveAddrOwnership("OTHER")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">Someone else</span>
                          </label>
                        </div>
                      </div>
                      {saveAddrSubmitAttempted && saveAddrOwnershipError ? (
                        <div className="withdraw_save_error" role="alert">
                          {saveAddrOwnershipError}
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_WALLET_TYPE ? (
                    <>
                      <p className="withdraw_save_confirm_lead">
                        Choose whether this withdrawal address is controlled in your own wallet or by an
                        exchange / virtual asset service provider.
                      </p>
                      <div className="withdraw_save_radio_block">
                        <p className="withdraw_save_radio_question" id="withdraw_save_self_wallet_type_question">
                          Address type
                        </p>
                        <div
                          className="withdraw_save_radio_rows"
                          role="radiogroup"
                          aria-labelledby="withdraw_save_self_wallet_type_question"
                        >
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_self_wallet_type"
                              checked={saveAddrWalletKindSelf === "SELF_HOSTED"}
                              onChange={() => setSaveAddrWalletKindSelf("SELF_HOSTED")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">
                              The address owner&apos;s self-hosted wallet
                            </span>
                          </label>
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_self_wallet_type"
                              checked={saveAddrWalletKindSelf === "EXCHANGE"}
                              onChange={() => setSaveAddrWalletKindSelf("EXCHANGE")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">
                              A wallet hosted by a Virtual Asset Service Provider / Exchange
                            </span>
                          </label>
                        </div>
                      </div>
                      {saveAddrSubmitAttempted && saveAddrWalletKindSelfError ? (
                        <div className="withdraw_save_error" role="alert">
                          {saveAddrWalletKindSelfError}
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_EXCHANGE ||
                    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_EXCHANGE ? (
                    <>
                      <p className="withdraw_whitelist_intro">
                        Select the exchange hosting this address, or choose Other to enter the institution
                        name manually.
                      </p>
                      <div className="withdraw_save_field">
                        <div className="withdraw_save_label" id="withdraw_save_exchange_label">
                          Exchange
                        </div>
                        <div
                          className={`withdraw_save_select_wrap${saveExchangeMenuOpen ? " is-open" : ""}`}
                          ref={saveExchangeSelectRef}
                        >
                          <button
                            type="button"
                            id="withdraw_save_exchange_pick"
                            className={`withdraw_save_select_trigger${!saveAddrExchangePick ? " is-placeholder" : ""}${saveAddrSubmitAttempted && saveAddrExchangeStepErrors.exchange ? " is-invalid" : ""
                              }`}
                            aria-haspopup="listbox"
                            aria-expanded={saveExchangeMenuOpen}
                            aria-labelledby="withdraw_save_exchange_label"
                            onClick={() => {
                              setSaveCoinMenuOpen(false);
                              setSaveNetworkMenuOpen(false);
                              setSaveExchangeMenuOpen((o) => !o);
                            }}
                          >
                            <span className="withdraw_save_select_value">
                              {!saveAddrExchangePick
                                ? "Select exchange"
                                : saveAddrExchangePick === ADDRESS_BOOK_EXCHANGE_OTHER
                                  ? "Other"
                                  : ADDRESS_BOOK_TOP_EXCHANGES.find((o) => o.value === saveAddrExchangePick)
                                    ?.label || "Select exchange"}
                            </span>
                          </button>
                          {saveExchangeMenuOpen ? (
                            <ul
                              className="withdraw_save_select_menu"
                              role="listbox"
                              aria-labelledby="withdraw_save_exchange_label"
                            >
                              {[...ADDRESS_BOOK_TOP_EXCHANGES, { value: ADDRESS_BOOK_EXCHANGE_OTHER, label: "Other" }].map(
                                (opt) => (
                                  <li key={opt.value} role="none">
                                    <button
                                      type="button"
                                      role="option"
                                      aria-selected={saveAddrExchangePick === opt.value}
                                      className={`withdraw_save_select_option${saveAddrExchangePick === opt.value ? " is-selected" : ""
                                        }`}
                                      onClick={() => {
                                        setSaveAddrExchangePick(opt.value);
                                        if (opt.value !== ADDRESS_BOOK_EXCHANGE_OTHER) {
                                          setSaveAddrExchangeManual("");
                                        }
                                        setSaveExchangeMenuOpen(false);
                                      }}
                                    >
                                      {opt.label}
                                    </button>
                                  </li>
                                )
                              )}
                            </ul>
                          ) : null}
                        </div>
                      </div>
                      {saveAddrExchangePick === ADDRESS_BOOK_EXCHANGE_OTHER ? (
                        <div className="withdraw_save_field">
                          <label className="withdraw_save_label" htmlFor="withdraw_save_exchange_manual">
                            Enter name manually
                          </label>
                          <input
                            id="withdraw_save_exchange_manual"
                            type="text"
                            className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrExchangeStepErrors.exchange ? " is-invalid" : ""
                              }`}
                            placeholder="Exchange or VASP name"
                            value={saveAddrExchangeManual}
                            onChange={(e) => setSaveAddrExchangeManual(e.target.value)}
                          />
                        </div>
                      ) : null}
                      {saveAddrSubmitAttempted && saveAddrExchangeStepErrors.exchange ? (
                        <div className="withdraw_save_error" role="alert">
                          {saveAddrExchangeStepErrors.exchange}
                        </div>
                      ) : null}
                      <div className="withdraw_save_field">
                        <div className="withdraw_save_label">Declaration</div>
                        <label className="withdraw_save_universal_main">
                          <input
                            type="checkbox"
                            checked={saveAddrDeclarationAccepted}
                            onChange={(e) => setSaveAddrDeclarationAccepted(e.target.checked)}
                          />
                          <span className="withdraw_save_universal_text">{ADDRESS_BOOK_DECLARATION_TEXT}</span>
                        </label>
                        {saveAddrSubmitAttempted && saveAddrExchangeStepErrors.declaration ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrExchangeStepErrors.declaration}
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_VERIFY ? (
                    <>
                      <p className="withdraw_whitelist_intro">
                        Verification method for your self-hosted wallet (same address entered above).
                      </p>
                      <div className="withdraw_save_radio_block">
                        <p className="withdraw_save_radio_question" id="withdraw_save_verify_method_question">
                          Verification method
                        </p>
                        {!saveAddrChainCanonical ? (
                          <p className="withdraw_whitelist_method_hint">
                            Select a network in the first step to choose how to verify this address.
                          </p>
                        ) : (
                          <>
                            <div
                              className="withdraw_save_radio_rows"
                              role="radiogroup"
                              aria-labelledby="withdraw_save_verify_method_question"
                            >
                              <label className="withdraw_save_radio_option">
                                <input
                                  type="radio"
                                  className="withdraw_save_radio_native"
                                  name="withdraw_save_whitelist_method"
                                  checked={saveAddrWhitelistMethod === "SATOSHI"}
                                  onChange={() => setSaveAddrWhitelistMethod("SATOSHI")}
                                />
                                <span className="withdraw_save_radio_visual" aria-hidden="true" />
                                <span className="withdraw_save_radio_text">Satoshi test</span>
                              </label>
                              <label
                                className={`withdraw_save_radio_option${!isMetaMaskWhitelistChain(saveAddrChainCanonical) ? " is-disabled" : ""
                                  }`}
                              >
                                <input
                                  type="radio"
                                  className="withdraw_save_radio_native"
                                  name="withdraw_save_whitelist_method"
                                  disabled={!isMetaMaskWhitelistChain(saveAddrChainCanonical)}
                                  checked={saveAddrWhitelistMethod === "METAMASK"}
                                  onChange={() => {
                                    if (isMetaMaskWhitelistChain(saveAddrChainCanonical)) {
                                      setSaveAddrWhitelistMethod("METAMASK");
                                    }
                                  }}
                                />
                                <span className="withdraw_save_radio_visual" aria-hidden="true" />
                                <span className="withdraw_save_radio_text">MetaMask signature</span>
                              </label>
                            </div>
                            {!isMetaMaskWhitelistChain(saveAddrChainCanonical) ? (
                              <p className="withdraw_whitelist_method_hint">
                                MetaMask is only available on EVM networks (e.g. BEP20, ERC20).
                              </p>
                            ) : null}
                          </>
                        )}
                      </div>
                      {saveAddrSubmitAttempted &&
                        saveAddrWhitelistMethod === "METAMASK" &&
                        saveAddrChainCanonical &&
                        !isMetaMaskWhitelistChain(saveAddrChainCanonical) ? (
                        <div className="withdraw_save_error" role="alert">
                          MetaMask verification is only available on supported EVM networks.
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_IDENTITY ? (
                    <>
                      <p className="withdraw_whitelist_intro">
                        Identify the recipient for this withdrawal address when it belongs to someone else.
                      </p>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_ben_name">
                          Full legal name
                        </label>
                        <input
                          placeholder="Enter full legal name"
                          id="withdraw_save_ben_name"
                          className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.fullName ? " is-invalid" : ""
                            }`}
                          type="text"
                          value={saveAddrBenFullName}
                          onChange={(e) => setSaveAddrBenFullName(e.target.value)}
                        />
                        {saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.fullName ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrOtherIdentityErrors.fullName}
                          </div>
                        ) : null}
                      </div>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_ben_pan">
                          PAN or National ID
                        </label>
                        <input
                          placeholder="Enter PAN or National ID"
                          id="withdraw_save_ben_pan"
                          className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.pan ? " is-invalid" : ""
                            }`}
                          type="text"
                          value={saveAddrBenPan}
                          onChange={(e) => setSaveAddrBenPan(e.target.value)}
                        />
                        {saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.pan ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrOtherIdentityErrors.pan}
                          </div>
                        ) : null}
                      </div>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_ben_country">
                          Country of residence
                        </label>
                        <div
                          className={`withdraw_save_country_select_wrap${saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.country ? " is-invalid" : ""
                            }`}
                        >
                          <Select
                            inputId="withdraw_save_ben_country"
                            instanceId="withdraw_save_ben_country"
                            classNamePrefix="withdraw-save-country"
                            placeholder="Select country"
                            isClearable={false}
                            isSearchable
                            options={countriesResidenceSelectOptions}
                            value={
                              countriesResidenceSelectOptions.find((o) => o.value === saveAddrBenCountry) ||
                              null
                            }
                            onChange={(opt) => setSaveAddrBenCountry(opt?.value ?? "")}
                            styles={withdrawSaveModalCountrySelectStyles}
                            menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                            menuPosition="fixed"
                            components={{
                              DropdownIndicator: WithdrawSaveCountryDropdownIndicator,
                              IndicatorSeparator: () => null,
                            }}
                          />
                        </div>
                        {saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.country ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrOtherIdentityErrors.country}
                          </div>
                        ) : null}
                      </div>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_ben_pin">
                          PIN / Postal code
                        </label>
                        <input
                          placeholder="Enter PIN or Postal code"
                          id="withdraw_save_ben_pin"
                          className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.pin ? " is-invalid" : ""
                            }`}
                          type="text"
                          value={saveAddrBenPin}
                          onChange={(e) => setSaveAddrBenPin(e.target.value)}
                        />
                        {saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.pin ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrOtherIdentityErrors.pin}
                          </div>
                        ) : null}
                      </div>
                      <div className="withdraw_save_field">
                        <label className="withdraw_save_label" htmlFor="withdraw_save_ben_address">
                          Full residential address
                        </label>
                        <textarea
                          id="withdraw_save_ben_address"
                          className={`withdraw_save_input${saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.address ? " is-invalid" : ""
                            }`}
                          rows={3}
                          value={saveAddrBenAddress}
                          onChange={(e) => setSaveAddrBenAddress(e.target.value)}
                        />
                        {saveAddrSubmitAttempted && saveAddrOtherIdentityErrors.address ? (
                          <div className="withdraw_save_error" role="alert">
                            {saveAddrOtherIdentityErrors.address}
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_WALLET_TYPE ? (
                    <>
                      <p className="withdraw_save_confirm_lead">
                        Indicate whether the beneficiary holds this cryptocurrency in their own custody or via
                        a service provider platform.
                      </p>
                      <div className="withdraw_save_radio_block">
                        <p className="withdraw_save_radio_question" id="withdraw_save_other_wallet_type_question">
                          Address type
                        </p>
                        <div
                          className="withdraw_save_radio_rows"
                          role="radiogroup"
                          aria-labelledby="withdraw_save_other_wallet_type_question"
                        >
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_other_wallet_type"
                              checked={saveAddrWalletKindOther === "SELF_HOSTED"}
                              onChange={() => setSaveAddrWalletKindOther("SELF_HOSTED")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">
                              Their self-hosted wallet
                            </span>
                          </label>
                          <label className="withdraw_save_radio_option">
                            <input
                              type="radio"
                              className="withdraw_save_radio_native"
                              name="withdraw_save_other_wallet_type"
                              checked={saveAddrWalletKindOther === "EXCHANGE"}
                              onChange={() => setSaveAddrWalletKindOther("EXCHANGE")}
                            />
                            <span className="withdraw_save_radio_visual" aria-hidden="true" />
                            <span className="withdraw_save_radio_text">
                              A wallet hosted by a Virtual Asset Service Provider / Exchange
                            </span>
                          </label>
                        </div>
                      </div>
                      {saveAddrSubmitAttempted && saveAddrWalletKindOtherError ? (
                        <div className="withdraw_save_error" role="alert">
                          {saveAddrWalletKindOtherError}
                        </div>
                      ) : null}
                    </>
                  ) : null}

                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.VERIFY_ACCOUNT ? (
                    <>
                      {addrBookVerificationOptionsLoading ? (
                        <div className="withdraw_whitelist_checking" role="status">
                          <WithdrawButtonSpinner />
                          Loading verification options…
                        </div>
                      ) : !(addrBookVerificationOptionsState?.available_methods ?? []).length ? (
                        <div className="withdraw_save_error" role="alert">
                          No verification methods are available right now.
                        </div>
                      ) : (
                        <div className="withdraw_addr_verify_identity">
                          <div className="withdraw_sec_confirm_hero" aria-hidden="true">
                            <img className="dark_img" src="/images/security/security_vector2.svg" alt="" />
                            <img className="light_img" src="/images/security/security_vector_light2.svg" alt="" />
                          </div>
                          {(addrBookVerificationOptionsState?.available_methods ?? []).length > 1 ? (
                            <>
                              <div className="withdraw_sec_title">Choose how to verify</div>
                              <div className="withdraw_sec_subtitle">
                                Select one option, then tap Continue. The next step is your code or passkey
                                prompt—no second method picker.
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="withdraw_sec_title">Confirm it&apos;s you</div>
                              <div className="withdraw_sec_subtitle">
                                Your account has a single verification option for this step. Tap Continue to open
                                the secure prompt and finish saving this withdrawal address.
                              </div>
                            </>
                          )}
                          <div
                            className="withdraw_sec_list"
                            role="radiogroup"
                            aria-label="Verification method"
                          >
                            {addrBookVerifyDisplayRows.map((row) => {
                              const selected = addrBookWizardSelectedMethod === row.id;
                              return (
                                <button
                                  key={row.id}
                                  type="button"
                                  className={`withdraw_sec_item withdraw_sec_item--selectable${selected ? " is-selected" : ""
                                    }`}
                                  role="radio"
                                  aria-checked={selected}
                                  onClick={() => setAddrBookWizardSelectedMethod(row.id)}
                                >
                                  <div className="withdraw_sec_item_left">
                                    <span className="withdraw_sec_icon" aria-hidden="true">
                                      <img src={row.icon} alt="" />
                                    </span>
                                    <span className="withdraw_sec_item_txt">
                                      <span className="withdraw_sec_item_title">{row.title}</span>
                                      {row.sub ? (
                                        <span className="withdraw_sec_item_sub">{row.sub}</span>
                                      ) : null}
                                    </span>
                                  </div>
                                  <span
                                    className={`withdraw_sec_check${selected ? " is-checked" : ""}`}
                                    aria-hidden="true"
                                  />
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  ) : null}
                </div>

                <div className="withdraw_save_actions">
                  {saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.BASICS ? (
                    <>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--cancel"
                        onClick={() => {
                          setIsSaveAddressOpen(false);
                          resetSaveAddressFormFields();
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--save"
                        disabled={saveAddrSaving || saveAddrBasicsNextDisabled}
                        onClick={() => saveAddrWizardGoNext()}
                      >
                        Next
                      </button>
                    </>
                  ) : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OWNER ||
                    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_WALLET_TYPE ||
                    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_IDENTITY ||
                    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_WALLET_TYPE ? (
                    <>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--cancel"
                        onClick={() => saveAddrWizardBack()}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--save"
                        disabled={saveAddrSaving}
                        onClick={() => saveAddrWizardGoNext()}
                      >
                        Next
                      </button>
                    </>
                  ) : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_EXCHANGE ||
                    saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.OTHER_EXCHANGE ? (
                    <>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--cancel"
                        onClick={() => saveAddrWizardBack()}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--save"
                        disabled={saveAddrSaving || !saveAddrDeclarationAccepted}
                        onClick={() => void handleSaveAddrExchangeStubSubmit()}
                      >
                        {saveAddrSaving ? "Working…" : "Submit"}
                      </button>
                    </>
                  ) : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.VERIFY_ACCOUNT ? (
                    <>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--cancel"
                        onClick={() => saveAddrWizardBack()}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--save"
                        disabled={
                          saveAddrSaving ||
                          addrBookVerificationOptionsLoading ||
                          !(addrBookVerificationOptionsState?.available_methods ?? []).length ||
                          !addrBookWizardSelectedMethod
                        }
                        onClick={() => void confirmAddrBookWizardVerification()}
                      >
                        Continue
                      </button>
                    </>
                  ) : saveAddrWizardStep === SAVE_ADDR_WIZARD_STEP.SELF_VERIFY ? (
                    <>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--cancel"
                        onClick={() => saveAddrWizardBack()}
                      >
                        Back
                      </button>
                      <button
                        type="button"
                        className="withdraw_save_btn withdraw_save_btn--save"
                        disabled={!isSaveAddrSelfVerifyValid || saveAddrSaving}
                        onClick={() => void handleSaveAddressBookSubmit()}
                      >
                        {saveAddrSaving ? "Working…" : "Continue"}
                      </button>
                    </>
                  ) : null}
                </div>
              </>
            )}
          </div>
        </div>
      ) : null}

      {metamaskInstallModalOpen ? (
        <div
          className="withdraw_confirm_overlay"
          role="presentation"
          onClick={() => setMetamaskInstallModalOpen(false)}
        >
          <div
            className="withdraw_confirm_modal withdraw_mm_install_modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="withdraw_mm_install_title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="withdraw_confirm_close"
              aria-label="Close"
              onClick={() => setMetamaskInstallModalOpen(false)}
            >
              ×
            </button>
            <h2 id="withdraw_mm_install_title" className="withdraw_ab_delete_confirm_title">
              Install MetaMask
            </h2>
            <div className="withdraw_confirm_text">
              MetaMask is a browser extension that lets you sign messages and approve transactions. Add
              it from the official site for your browser, enable it, then reload this page to continue.
            </div>
            <div className="withdraw_confirm_actions">
              <button
                type="button"
                className="withdraw_confirm_btn withdraw_confirm_btn--ghost"
                onClick={() => setMetamaskInstallModalOpen(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="withdraw_confirm_btn withdraw_confirm_btn--primary"
                onClick={() => {
                  window.open(METAMASK_DOWNLOAD_URL, "_blank", "noopener,noreferrer");
                  setMetamaskInstallModalOpen(false);
                }}
              >
                Get MetaMask
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {addressBookDeleteConfirm ? (
        <div className="withdraw_confirm_overlay" role="presentation">
          <div
            className="withdraw_confirm_modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="withdraw_ab_delete_confirm_title"
          >
            <button
              type="button"
              className="withdraw_confirm_close"
              aria-label="Close"
              disabled={addressBookDeleteBusy}
              onClick={() => {
                if (!addressBookDeleteBusy) setAddressBookDeleteConfirm(null);
              }}
            >
              ×
            </button>

            <div className="withdraw_confirm_icon" aria-hidden="true">
              <div className="withdraw_confirm_envelope">
                <img src="/images/email_vector.svg" alt="" />
              </div>
            </div>

            <h2 id="withdraw_ab_delete_confirm_title" className="withdraw_ab_delete_confirm_title">
              {addressBookDeleteConfirmTitle(addressBookDeleteConfirm)}
            </h2>
            <div className="withdraw_confirm_text">
              {addressBookDeleteConfirmMessage(addressBookDeleteConfirm)}
            </div>

            <div className="withdraw_confirm_actions">
              <button
                type="button"
                className="withdraw_confirm_btn withdraw_confirm_btn--ghost"
                disabled={addressBookDeleteBusy}
                onClick={() => setAddressBookDeleteConfirm(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="withdraw_confirm_btn withdraw_confirm_btn--primary"
                disabled={addressBookDeleteBusy}
                onClick={() => void confirmAddressBookDelete()}
              >
                {addressBookDeleteBusy ? (
                  <>
                    <WithdrawButtonSpinner />
                    Removing…
                  </>
                ) : (
                  "Remove"
                )}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
